module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n      "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n        ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n        ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-11",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-togglebutton": "false",
      "data-widget-deletebutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "role": "widget"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "tab-content m-b-10 padding-10"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "hr1"
    }
  }, [_c('custom-form', {
    ref: "customFormPersonalData",
    attrs: {
      "group": 1,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr2"
    }
  }, [_c('custom-form', {
    ref: "customFormOffice",
    attrs: {
      "group": 2,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr3"
    }
  }, [_c('custom-form', {
    ref: "customFormGuaranter",
    attrs: {
      "group": 3,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticClass: "pull-right",
    staticStyle: {
      "right": "20px"
    }
  }, [_c('strong', [_vm._v("DADOS DO CLIENTE")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "widget-tab-1"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-1",
      "href": "#hr1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-address-card-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS GERAIS ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-2",
      "href": "#hr2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS PROFISSIONAIS ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-3",
      "href": "#hr3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" CÔNJUGE/AVALISTA ")])])])]), _vm._v(" "), _c('span', {
    staticClass: "jarviswidget-loader"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb9ea42e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Show/ShowPage.vue
// module id = 1078
// module chunks = 1